import type { FC } from "react";
import { useAuth } from "../../../../app/modules/auth";
import { KTIcon } from "../../../helpers";
import { useLayout } from "../../core";
import { AsideMenu } from "./AsideMenu";

const AsideDefault: FC = () => {
	const { classes } = useLayout();
	const { logout } = useAuth();
	return (
		<div
			id="kt_aside"
			className="aside glass-effect"
			data-kt-drawer="true"
			data-kt-drawer-name="aside"
			data-kt-drawer-activate="{default: true, lg: false}"
			data-kt-drawer-overlay="true"
			data-kt-drawer-width="{default:'200px', '300px': '250px'}"
			data-kt-drawer-direction="start"
			data-kt-drawer-toggle="#kt_aside_mobile_toggle"
		>
			{/* begin::Aside Toolbarl */}
			{/* <div className='aside-toolbar flex-column-auto' id='kt_aside_toolbar'>
        <AsideToolbar />
      </div> */}
			{/* end::Aside Toolbarl */}
			{/* begin::Aside menu */}
			<div className="aside-menu flex-column-fluid">
				<AsideMenu asideMenuCSSClasses={classes.asideMenu} />
			</div>
			{/* end::Aside menu */}

			{/* begin::Footer */}
			<div className="aside-footer flex-column-auto py-5" id="kt_aside_footer">
				<a
					className="btn btn-primary w-100"
					onClick={logout}
					data-bs-toggle="tooltip"
					data-bs-trigger="hover"
					data-bs-dismiss-="click"
					title="Sign out"
				>
					<span className="btn-label">Sign Out</span>
					<span className="btn-icon fs-3">
						<KTIcon iconName="exit-right" className="ms-2" />
					</span>
				</a>
			</div>
			{/* end::Footer */}
		</div>
	);
};

export { AsideDefault };
